import React, { forwardRef } from 'react';
import { FiChevronDown } from 'react-icons/fi';

const Select = forwardRef(({
  options = [],
  value,
  onChange,
  name,
  id,
  placeholder = 'Select an option',
  disabled = false,
  error,
  size = 'default',
  className = '',
  children,
  ...props
}, ref) => {
  const sizeClasses = {
    sm: 'h-9 py-2 pl-3 pr-9 text-sm',
    default: 'h-12 py-3 pl-4 pr-10',
    lg: 'h-14 py-4 pl-6 pr-12 text-lg',
  };

  const baseClasses = `
    w-full appearance-none rounded-lg border bg-transparent
    outline-none transition-all duration-200
    focus:border-brand-500 focus-visible:shadow-none
    dark:bg-meta-4 dark:text-white
    disabled:cursor-not-allowed disabled:opacity-50
    ${sizeClasses[size] || sizeClasses.default}
  `;

  const stateClasses = error
    ? 'border-danger focus:border-danger'
    : 'border-stroke dark:border-strokedark';

  const iconSize = size === 'sm' ? 16 : size === 'lg' ? 24 : 18;
  const iconRight = size === 'sm' ? 'right-2.5' : size === 'lg' ? 'right-4' : 'right-3';

  return (
    <div className="relative">
      <select
        ref={ref}
        name={name}
        id={id || name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={`${baseClasses} ${stateClasses} ${className}`}
        {...props}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {children || options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      <span className={`absolute ${iconRight} top-1/2 -translate-y-1/2 pointer-events-none text-body`}>
        <FiChevronDown size={iconSize} />
      </span>
    </div>
  );
});

Select.displayName = 'Select';

export default Select;
